import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { dashboardService } from '../services/dashboard.service';
import { DashboardSummary } from '../types';

interface DashboardState {
  summary: DashboardSummary | null;
  loading: boolean;
  error: string | null;
  isLiveTrading: boolean;
  lastUpdate: Date | null;
}

const initialState: DashboardState = {
  summary: null,
  loading: false,
  error: null,
  isLiveTrading: false,
  lastUpdate: null
};

export const fetchDashboardSummary = createAsyncThunk(
  'dashboard/fetchSummary',
  async (alertDays?: number) => {
    const response = await dashboardService.getSummary(alertDays);
    return response.data.data;
  }
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setLiveTrading: (state, action: PayloadAction<boolean>) => {
      state.isLiveTrading = action.payload;
    },
    updateMetrics: (state, action: PayloadAction<Partial<DashboardSummary>>) => {
      if (state.summary) {
        state.summary = { ...state.summary, ...action.payload };
      }
      state.lastUpdate = new Date();
    },
    resetDashboard: (state) => {
      state.summary = null;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardSummary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardSummary.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.summary = action.payload;
          state.lastUpdate = new Date();
        }
      })
      .addCase(fetchDashboardSummary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch dashboard';
      });
  }
});

export const { setLiveTrading, updateMetrics, resetDashboard } = dashboardSlice.actions;
export default dashboardSlice.reducer;
